/**
 * Normalise employment gap status across canonical review, legacy rows, and API records.
 */
export function normalizeGapStatus(gap) {
  if (!gap || typeof gap !== 'object') return 'pending';

  const raw = String(gap.raw_status || gap.status || 'pending').toLowerCase();
  const hasExplanation = Boolean(
    (typeof gap.explanation === 'string' && gap.explanation.trim())
    || gap.explanation?.text
    || gap.explanation?.explanation
  );

  if (raw === 'verified') return 'verified';
  if (raw === 'explained' || (hasExplanation && !['verified', 'rejected', 'reopened'].includes(raw))) {
    return 'explained';
  }
  if (raw === 'rejected') return 'rejected';
  if (raw === 'needs_more_info') return 'needs_more_info';
  if (raw === 'reopened') return 'reopened';
  if (raw === 'missing' || raw === 'pending') return hasExplanation ? 'explained' : 'pending';
  return hasExplanation ? 'explained' : 'pending';
}

export function normalizeGapRecord(gap) {
  if (!gap || typeof gap !== 'object') return gap;
  const explanation =
    typeof gap.explanation === 'string'
      ? gap.explanation
      : (gap.explanation?.text || gap.explanation?.explanation || gap.explanation);
  return {
    ...gap,
    gap_id: gap.gap_id || gap.id,
    gap_start: gap.gap_start || gap.start_date,
    gap_end: gap.gap_end || gap.end_date,
    explanation,
    status: normalizeGapStatus({ ...gap, explanation }),
  };
}